import React from "react";
import { IoSpeedometerOutline } from "react-icons/io5";
import { GiCheckedShield } from "react-icons/gi";
import { RiDashboardFill } from "react-icons/ri";

function Accesoriess({ type }) {
    if (type === 2) {
        return (
            <div className="z-0 mx-auto max-w-screen-2xl animate-pulse -mr-20">
                <div className="flex justify-end">
                    <svg width="269" height="359" viewBox="0 0 269 359" fill="none" className="absolute z-0 -mt-48" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="153.055" cy="115.055" r="115.055" fill="#1C3970" />
                        <circle cx="95.1417" cy="199.142" r="95.1417" fill="#34B3FF" />
                        <circle cx="174.945" cy="278.937" r="79.6535" fill="#96F2FF" />
                    </svg>
                </div>
            </div>
        );
    }
    return (
        <div className="z-0 mx-auto max-w-screen-2xl animate-pulse -ml-20">
            <div className="flex justify-start">
                <svg width="269" height="359" viewBox="0 0 269 359" fill="none" className="absolute z-0 -mt-16" xmlns="http://www.w3.org/2000/svg">
                    <circle r="115.055" transform="matrix(-1 0 0 1 115.945 115.055)" fill="#1C3970" />
                    <circle r="95.1417" transform="matrix(-1 0 0 1 173.858 199.142)" fill="#34B3FF" />
                    <circle r="79.6535" transform="matrix(-1 0 0 1 94.055 278.937)" fill="#96F2FF" />
                </svg>
            </div>
        </div>
    );
}

function Home() {
    return (
        <React.Fragment>
            <main>
                <div className="main-container font-poppins overflow-hidden lg:w-3/4 mx-auto">
                    <section className="flex flex-col w-full text-center items-center justify-center px-8 lg:p-0 h-screen">
                        <h1 className=" font-extrabold font-mono text-3xl sm:text-5xl lg:text-6xl text-white">Tell about your secret without anyone knowing who you are.</h1>
                        <p className="my-6 text-md lg:text-xl  text-slate-400 text-center min-w-3xl mx-auto">
                            A place where you can <span className="font-poppins font-medium text-sky-400">express your feelings</span> anonymously.
                        </p>
                        <div className="button flex flex-col sm:flex-row justify-center md:justify-around w-full md:w-max gap-4">
                            <a
                                href="/create"
                                className=" whitespace-nowrap z-10  focus:outline-none focus:ring-2  text-white font-semibold h-12 px-6 rounded-lg w-full flex items-center justify-center sm:w-auto bg-sky-500 highlight-white/20 hover:bg-sky-600"
                            >
                                Get Started
                            </a>
                            <a
                                href="/about"
                                className="bg-transparent  whitespace-nowrap z-10 border-sky-600 border-2 focus:outline-none focus:ring-2  text-white font-semibold h-12 px-6 rounded-lg w-full flex items-center justify-center sm:w-auto hover:bg-sky-600 dark:highlight-white/20 dark:hover:bg-sky-600"
                            >
                                Learn More
                            </a>
                        </div>
                        <Accesoriess />
                    </section>
                    <section className="max-w-screen-2xl mx-auto">
                        <div className="py-24">
                            <div className="flex z-10 justify-center gap-16 items-center flex-col px-4 lg:px-4 mx-auto">
                                <div className="text-4xl z-10 font-bold leading-tight text-center heading text-white md:text-4xl lg:text-5xl lg:leading-snug font-mono">
                                    The easiest and the safest way to
                                    <span className="text-sky-400"> tell your secret</span>
                                </div>
                                <div className="flex flex-col lg:flex-row gap-4 items-center w-3/4 md:w-1/2 lg:w-full justify-around ">
                                    <div className="flex basis-1/3 flex-col justify-center text-center lg:text-left lg:justify-start">
                                        <GiCheckedShield size="53px" className="mx-auto lg:m-0" color="34B3FF" />
                                        <div className="mt-5 mb-3 font-bold value-title md:mt-9 text-white dark:text-light-1 text-md lg:text-lg">Security First</div>
                                        <p className="my-6 text-md lg:text-lg text-center lg:text-left  min-w-3xl mx-auto text-slate-400">Absolutely no user data is obtained except what the user sends in the form.</p>
                                    </div>
                                    <div className="flex basis-1/3 flex-col justify-center text-center  lg:text-left lg:justify-start">
                                        <RiDashboardFill size="53px" className="mx-auto lg:m-0" color="34B3FF" />
                                        <div className="mt-5 mb-3 font-bold value-title md:mt-9 text-white text-md lg:text-lg">Easy to Use</div>
                                        <p className="my-6 text-md lg:text-lg text-center lg:text-left  min-w-3xl mx-auto text-slate-400">All features are available with a good user experience and easy to use.</p>
                                    </div>
                                    <div className=" flex basis-1/3 flex-col justify-center text-center lg:text-left lg:justify-start">
                                        <IoSpeedometerOutline size="53px" className="mx-auto lg:m-0" color="34B3FF" />
                                        <div className="mt-5 mb-3 font-bold value-title md:mt-9 text-white text-md lg:text-lg">Fast Update</div>
                                        <p className="my-6 text-md lg:text-lg text-center lg:text-left  min-w-3xl mx-auto text-slate-400">The data that the user sends will be immediately visible after the user submits.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/*  */}
                    <section class="h-auto font-poppins">
                        <main class="flex flex-col gap-12 px-4 py-20 mx-auto max-w-screen-2xl lg:px-24">
                            <div class="flex flex-col items-center justify-center gap-5">
                                <div class="text-lg font-bold text-center text-sky-400 uppercase">How to start?</div>
                                <div class="text-4xl md:text-5xl font-mono font-bold text-slate-200 text-center text-dark-1 leading-normal lg:leading-snug">
                                    3-Steps to send <br class="hidden lg:block" />
                                    your own confession
                                </div>
                            </div>
                            <div class="grid items-center justify-center h-full gap-5 md:grid-cols-12">
                                <div class="h-full md:col-span-6 lg:col-span-4">
                                    <div class="flex flex-col items-center justify-center pb-10 bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl h-max px-9 pt-14">
                                        <div>
                                            <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="53" cy="53" r="52.5" stroke="#E5D4FF" />
                                                <circle cx="53" cy="53" r="45" fill="#E5D4FF" />
                                                <path
                                                    d="M65 66.5V63.5C65 61.9087 64.3679 60.3826 63.2426 59.2574C62.1174 58.1321 60.5913 57.5 59 57.5H47C45.4087 57.5 43.8826 58.1321 42.7574 59.2574C41.6321 60.3826 41 61.9087 41 63.5V66.5"
                                                    stroke="#654B8C"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M53 51.5C56.3137 51.5 59 48.8137 59 45.5C59 42.1863 56.3137 39.5 53 39.5C49.6863 39.5 47 42.1863 47 45.5C47 48.8137 49.6863 51.5 53 51.5Z"
                                                    stroke="#654B8C"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </div>
                                        <div class="mt-10 mb-3 text-lg font-semibold text-slate-200">Get Started</div>
                                        <p class="text-base font-medium text-center text-slate-200">Go to Create Page to get start to send your message</p>
                                    </div>
                                </div>
                                <div class="h-full md:col-span-6 lg:col-span-4">
                                    <div class="flex flex-col items-center justify-center pb-10 bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl h-max px-9 pt-14">
                                        <div>
                                            <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="53" cy="53" r="52.5" stroke="#FCE1D8" />
                                                <circle cx="53" cy="53" r="45" fill="#FDE1D7" />
                                                <path
                                                    d="M65 45.5H41C39.3431 45.5 38 46.8431 38 48.5V63.5C38 65.1569 39.3431 66.5 41 66.5H65C66.6569 66.5 68 65.1569 68 63.5V48.5C68 46.8431 66.6569 45.5 65 45.5Z"
                                                    stroke="#B67E6A"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M59 66.5V42.5C59 41.7044 58.6839 40.9413 58.1213 40.3787C57.5587 39.8161 56.7956 39.5 56 39.5H50C49.2044 39.5 48.4413 39.8161 47.8787 40.3787C47.3161 40.9413 47 41.7044 47 42.5V66.5"
                                                    stroke="#B67E6A"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </div>
                                        <div class="mt-10 mb-3 text-lg font-semibold text-slate-200">Submit Message</div>
                                        <p class="text-base font-medium text-center text-slate-200">Submitting your message through our database.</p>
                                    </div>
                                </div>
                                <div class="h-full md:col-span-6 lg:col-span-4">
                                    <div class="flex flex-col items-center justify-center pb-10 bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl h-max px-9 pt-14">
                                        <div>
                                            <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="53" cy="53" r="52.5" stroke="#FFECC2" />
                                                <circle cx="53" cy="53" r="45" fill="#FFECC2" />
                                                <path
                                                    d="M68 39.5H59C57.4087 39.5 55.8826 40.1321 54.7574 41.2574C53.6321 42.3826 53 43.9087 53 45.5V66.5C53 65.3065 53.4741 64.1619 54.318 63.318C55.1619 62.4741 56.3065 62 57.5 62H68V39.5Z"
                                                    stroke="#9F854C"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                                <path
                                                    d="M38 39.5H47C48.5913 39.5 50.1174 40.1321 51.2426 41.2574C52.3679 42.3826 53 43.9087 53 45.5V66.5C53 65.3065 52.5259 64.1619 51.682 63.318C50.8381 62.4741 49.6935 62 48.5 62H38V39.5Z"
                                                    stroke="#9F854C"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </div>
                                        <div class="mt-10 mb-3 text-lg font-semibold text-slate-200">All Confession</div>
                                        <p class="text-base font-medium text-center text-slate-200">See all the confession that you and user already submit.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="button flex flex-col sm:flex-row mx-auto justify-center md:justify-around w-full md:w-max gap-4">
                                <a
                                    href="/create"
                                    className=" whitespace-nowrap z-10  focus:outline-none focus:ring-2  text-white font-semibold h-12 px-6 rounded-lg w-full flex items-center justify-center sm:w-auto bg-sky-500 highlight-white/20 hover:bg-sky-600"
                                >
                                    Get Started
                                </a>
                                <a
                                    href="/about"
                                    className="bg-transparent  whitespace-nowrap z-10 border-sky-600 border-2 focus:outline-none focus:ring-2  text-white font-semibold h-12 px-6 rounded-lg w-full flex items-center justify-center sm:w-auto hover:bg-sky-600 dark:highlight-white/20 dark:hover:bg-sky-600"
                                >
                                    Learn More
                                </a>
                            </div>
                        </main>
                    </section>
                </div>
            </main>
        </React.Fragment>
    );
}

export default Home;
